var render = function render(){var _vm=this,_c=_vm._self._c;return _c('res-select',{ref:"selector",staticClass:"template-selector",attrs:{"readonly":_vm.readonly,"items":_vm.templates,"attach":_vm.attach,"menuProps":_vm.menuProps,"loading":_vm.loading,"return-object":""},model:{value:(_vm.selectedTemplate),callback:function ($$v) {_vm.selectedTemplate=$$v},expression:"selectedTemplate"}})
}
var staticRenderFns = []

export { render, staticRenderFns }